import { Icon } from './Icon';

/**
 * Стрелка выбора: плоский шеврон 12×8.
 *
 * Шире, чем выше, — и именно так он читается как «раскрыть», а не как «идти
 * вниз». Коробка у него своя, но обвязка общая: отдельный `<svg>` разъезжается
 * с набором на первой же правке.
 */
export function ChevronDownIcon() {
  return (
    <Icon size={8} box={[12, 8]} strokeWidth={1.3}>
      <path d="M1 1.5 L6 6.5 L11 1.5" />
    </Icon>
  );
}
